import styled from "styled-components";
import { DropdownButton } from "../Dropdown";

export const Button = styled.button`
  background-color: var(${(props) => props.backgroundColor});
  text-transform: uppercase;
  color: var(${(props) => props.color});
  overflow: auto;
  width: fit-content;
  align-self: ${(props) => props.align};
  visibility: ${(props) => props.isHidden};
  padding: 6px 12px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  border: 1px solid transparent;
  font-size: 0.9rem;
  border-radius: 0.25rem;
  vertical-align: middle;
  margin-top: ${(props) =>
    props.hasEspecificMargin ? props.hasEspecificMargin : "20px"};
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 144, 220, 0.25);
  }

  :disabled {
    opacity: 0.65;
  }

  :hover {
    color: var(${(props) => props.backgroundColor});
    border-color: var(${(props) => props.backgroundColor});
    background-color: transparent;
  }

  @media (max-width: 760px) {
    width: 100%;
    font-size: 1.2rem;
  }
`;

export const OperationButton = styled.button`
  font-weight: bold;
  font-size: 1.8rem;
  padding: 0 0.8rem 0 0.8rem;
  margin: auto 0 auto 0;
  text-align: center;
  color: white;
  background-color: #38c172;
  border: 0.0625rem solid #38c172;
  border-radius: 10%;
`;

export const ButtonCreate = styled.button`
  background-color: var(${(props) => props.color});
  text-transform: uppercase;
  color: #fff;
  width: fit-content;
  align-self: ${(props) => props.align};
  padding: ${props=> props.isDrop ? 0 : `6px 12px`};
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  border: 1px solid transparent;
  font-size: 0.9rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 144, 220, 0.25);
  }

  :disabled {
    opacity: 0.65;
  }

  ${DropdownButton} label {
    font-size: 1rem;
    color: #fff;
    margin-bottom: 0;
  }

  ${DropdownButton} {
    height: fit-content;
  }

  :hover {
    color: var(${(props) => props.color});
    border-color: var(${(props) => props.color});
    background-color: transparent;
    ${DropdownButton} label {
      color: var(${(props) => props.color});
    }
  }

  @media screen and (min-width: 992px) {
    ${DropdownButton} {
      font-size: 1rem !important;
    }
  }

  @media (max-width: 760px) {
    width: 100%;
    font-size: 1.2rem;
  }
`;

export const ButtonA = styled.a`
  background-color: var(${(props) => props.backgroundColor});
  color: var(${(props) => props.color});
  padding: 5px 8px;
  border-radius: 5px;
  border: transparent 1px solid;
  max-height: 36px;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  :hover {
    color: var(${(props) => props.backgroundColor});
    background-color: #fff;
    border: var(${(props) => props.backgroundColor}) 1px solid;
  }
`;

export const ButtonAlternative = styled.a`
  padding: 5px;
  color: var(--orange);
  font-weight: bold;
  border: 1px solid transparent;

  :hover {
    text-decoration: none;
    color: var(--orange);
    border-color: var(--orange);
    border-radius: 5px;
  }

  :target {
    background-color: var(--orange);
    border-radius: 5px;
    color: white;
  }
`;

export const ButtonPagination = styled.button`
  background-color: var(--light-fake-blue);
  border: 1px solid var(--light-blue);
  border-radius: 5px;
  color: white;
  margin-right: 5px;
  margin-bottom: 20px;
  padding: 0 5px 2px 5px;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
    background-color: var(--form-left);
    border-color: var(--form-left);
    color: var(--light-blue);
  }
`;

export const ButtonAlter = styled.label`
  margin: auto 0 0 0;
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid transparent;
  width: fit-content;
  height: fit-content;
  cursor: pointer;

  font-size: 0.9rem;
  font-weight: bold;
  padding: 5px;
  color: var(--orange);

  input[type="radio"] {
    display: none;
  }

  ${(props) =>
    props.hasTotal === true
      ? `background-color: var(--orange);
    color: white;`
      : ""}
`;
